import { snap } from '@m/alchemy-ui/theme';

import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  height: ${snap(100)};
`;
